import Cookies from 'js-cookie'
import { z } from 'zod'

export const REFERRAL_COOKIE_KEY = 'stampede.referral_org_id'

const REFERRAL_COOKIE_DAYS = 180

/**
 * Last-click-wins: always overwrites any existing referral cookie.
 *
 * A non-UUID org id (a malformed or tampered link) is silently ignored rather
 * than stored — Morpheus only accepts a UUID here too.
 **/
export function setReferralOrgId(orgId: string): void {
  // fail fast if it's not a valid uuid.
  if (!z.uuid().safeParse(orgId).success) {
    return
  }

  Cookies.set(REFERRAL_COOKIE_KEY, orgId, {
    expires: REFERRAL_COOKIE_DAYS,
    sameSite: 'lax',
  })
}

/**
 * Returns `undefined` if absent or the stored value isn't a valid UUID
 * (e.g. an old cookie from before this check, or direct tampering).
 **/
export function getReferralOrgId(): string | undefined {
  const value = Cookies.get(REFERRAL_COOKIE_KEY)

  if (!value || !z.uuid().safeParse(value).success) {
    return undefined
  }

  return value
}
